/**
 * Geography API
 * Provides access to US states and counties reference data
 */

import { apiClient } from '@/core/api/client';

export type USCounty = {
  id: string;
  fipsCode: string;
  stateFipsCode: string;
  stateCode: string | null;
  name: string;
};

export type USState = {
  id: string;
  code: string;
  fipsCode: string;
  name: string;
};

/**
 * Get all US counties, optionally filtered by state code
 */
export const getCounties = async (stateCode?: string): Promise<USCounty[]> => {
  const params = stateCode ? { stateCode } : {};
  const response = await apiClient.get<USCounty[]>('/geography/counties', { params });
  return response.data;
};

/**
 * Get all US states
 */
export const getStates = async (): Promise<USState[]> => {
  const response = await apiClient.get<USState[]>('/geography/states');
  return response.data;
};
